import React, { useContext, useState, useEffect, useCallback } from 'react'
import { useRetirementGapCalculations } from 'layouts/authenticated/pages/dashboard/hooks/useRetirementGapCalculations'
import { apiClient } from 'utils/api/apiClient'

// @mui core components
import { Box, Card, Grid, Typography } from '@mui/material'

// Data
import { IntakeContext } from 'context/IntakeContext'
import { selectData } from 'layouts/onboarding'

// Popup
import { toast } from 'react-toastify'
import { renderMuiFormField } from 'utils/forms/renderMuiFormField'

// Debounce
import { useFormDebounce } from 'hooks/useFormDebounce'
import LoadingButton from 'components/LoadingButton'

function Other() {
  const { intakeState, updateIntakeStateAtKey, updateUser } =
    useContext(IntakeContext)

  const { updateIntakeStateAndSubmit, loading } = useFormDebounce()

  const showSurvivorBenefit = intakeState?.familyMaritalStatus === 'married'
  const showSurvivorBenefitOwed = intakeState?.familyDivorcedOwedPension

  const [assets, setAssets] = useState([])
  const [liabilities, setLiabilities] = useState([])
  const [deductions, setDeductions] = useState([])
  const [incomes, setIncomes] = useState([])
  const [expenses, setExpenses] = useState([])

  const [assetsLoaded, setAssetsLoaded] = useState(false)

  const getAccounts = useCallback(async () => {
    try {
      const {
        data: { items },
      } = await apiClient.get('api/assets')

      const foundAssets = items?.filter(({ type }) => type === 'asset') || []
      setAssets(foundAssets)

      const foundLiabilities =
        items?.filter(({ type }) => type === 'liability') || []
      setLiabilities(foundLiabilities)

      const foundDeductions =
        items?.filter(({ type }) => type === 'deduction') || []
      setDeductions(foundDeductions)

      const foundIncomes = items?.filter(({ type }) => type === 'income') || []
      setIncomes(foundIncomes)

      const foundExpenses =
        items?.filter(({ type }) => type === 'expense') || []
      setExpenses(foundExpenses)

      setAssetsLoaded(true)
    } catch (error) {
      console.error('Failed to fetch accounts', error)
      setAssetsLoaded(false)
    }
  }, [])

  useEffect(() => {
    getAccounts()
  }, [getAccounts])

  // add an onSubmit button and call the context function `updateUser`
  // const onSubmit = () => updateUser()
  const onSubmit = async () => {
    await updateUser()
    toast.info('You have successfully updated your Other details', {
      position: 'top-center',
      autoClose: 5000,
      pauseOnFocusLoss: false,
      pauseOnHover: false,
    })
  }
  // console.log(intakeState.retirementLifestyleGoal)
  const [localForm, setLocalForm] = useState({
    retirementLifestyle:
      intakeState?.retirementLifestyleGoal?.retirementLifestyle || '',
    lifestyleGoal: intakeState?.retirementLifestyleGoal?.lifestyleGoal || '',
  })
  // console.log(localForm)
  const handleChange = (field) => (value) => {
    setLocalForm((prev) => ({ ...prev, [field]: value }))
  }
  const onBlur = () => {
    updateIntakeStateAndSubmit(() =>
      updateIntakeStateAtKey({
        retirementLifestyleGoal: localForm,
      })
    )()
  }
  const { adjustedNetTakeHomeInRetirement, adjustedWorkingNetTakeHome } =
    useRetirementGapCalculations(deductions, liabilities, incomes, expenses)
  // const parcoLifestyleGoal = localForm?.lifestyleGoal || 1
  // const parcoGapAdjustedForLifestyleGoal =
  //   adjustedWorkingNetTakeHome * parcoLifestyleGoal -
  //   adjustedNetTakeHomeInRetirement

  // const parcoAnnuityRecommendation = parcoAnnuityRecommendationCalculator({
  //   dateOfBirth: intakeState?.dateOfBirth,
  //   plannedRetirementDate: intakeState?.dateOfPlannedRetirement,
  //   netIncomeGap: parcoGapAdjustedForLifestyleGoal,
  // })
  // const parcoAnnuityRecommendationUnadjusted =
  //   parcoAnnuityRecommendationCalculator({
  //     dateOfBirth: intakeState?.dateOfBirth,
  //     plannedRetirementDate: intakeState?.dateOfPlannedRetirement,
  //     netIncomeGap: adjustedNetTakeHomeDifferencePARCOGap,
  //   })
  const minimumRetirement =
    adjustedNetTakeHomeInRetirement / adjustedWorkingNetTakeHome
  const splitTheGap = (minimumRetirement + 1) / 2
  // const affordCurrentLifestyle =
  //   parcoAnnuityRecommendationUnadjusted?.roundedCurrentAge >= 70
  //     ? valueOfInvestableAssets >=
  //       parcoAnnuityRecommendationUnadjusted.fourPercent
  //     : valueOfInvestableAssets >=
  //       parcoAnnuityRecommendationUnadjusted.threePercent

  return (
    <>
      <Box
        pl={3}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <Typography display="flex" align="left" variant="body2FunHeader">
          OTHER
        </Typography>

        <LoadingButton loading={loading} onClick={onSubmit} />
      </Box>
      <Card>
        <Box component="form" p={3}>
          <Grid container columnSpacing={3} rowSpacing={2}>
            <Grid item xs={12} sm={6}>
              {renderMuiFormField({
                autoFocus: false,
                id: 'test',
                label: 'Retirement Lifestyle Goal',
                placeholder: '',
                inputType: 'select',
                value: localForm.lifestyleGoal,
                onChange: (e) => handleChange('lifestyleGoal')(e),
                onBlur: onBlur,
                options: [
                  {
                    value: minimumRetirement,
                    label: `${Math.round(
                      minimumRetirement * 100
                    )}% - I want to live off just my pension and social security`,
                  },
                  {
                    value: splitTheGap,
                    label: `${Math.round(
                      splitTheGap * 100
                    )}% - I can live off a bit less than my current income`,
                  },
                  {
                    value: 1,
                    label: '100% - I want to maintain my current lifestyle',
                  },
                ],
              })}
            </Grid>
            <Grid item xs={12} sm={6}>
              {renderMuiFormField({
                autoFocus: false,
                id: 'giftCard',
                label: 'Preferred Gift Card',
                placeholder: '',
                inputType: 'select',
                value: intakeState.giftCard,
                onChange: updateIntakeStateAndSubmit((giftCard) =>
                  updateIntakeStateAtKey({ giftCard })
                ),
                options: selectData.giftCards,
              })}
            </Grid>
          </Grid>
        </Box>
      </Card>
    </>
  )
}

export default React.memo(Other)
